import { render, staticRenderFns } from "./SlrcN_Details.vue?vue&type=template&id=5b536e87"
import script from "./SlrcN_Details.vue?vue&type=script&lang=js"
export * from "./SlrcN_Details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports